module.exports = __webpack_public_path__ + "img/123.f5927684.png";